<template>
  <div>
    <p>
      <Loader :showAnimation='downloading' :msg="downloading?'Descarga en ejecución. Por favor, espere...': (error?'Ha ocurrido un error. Por favor, inténtelo de nuevo. Si el problema persiste, por favor contacte con el administrador web.':'Descarga terminada. Puede cerrar esta pestaña del navegador.')" fullPage></Loader>
    </p>
  </div>
</template>

<script>
import Loader from '@/components/Layout/Loader.vue';
import saveAs from 'file-saver';

const ReconnectingWebSocket = require('reconnecting-websocket');

import Vue from 'vue';

export default {
  name: 'download',
  components: {
    Loader
  },
  data () {
    return {
      id: null,
      downloading: false,
      socket: null,
      error: false
    };
  },
  computed: {
  },
  mounted: function () {
    var wsPath = Vue.http.options.ws_root; // wsScheme + '://' + process.env.HOSTIP + ':' + process.env.API + '/api/'
    this.socket = new ReconnectingWebSocket(wsPath);

    var th = this;

    this.socket.onmessage = function (message) {
      var data = JSON.parse(message.data);
      if (data.action === 'completed') {
        th.downloading = false;
        th.error = false;
        saveAs(th.$http.options.root.split('api/')[0] + 'media/' + data.path, data.filename);
      } else if (data.action === 'Error' || data.action === 'error') {
        th.downloading = false;
        th.error = true;
        alert('Failed');
      } else if (data.action === 'Empty' || data.action === 'empty') {
        th.downloading = false;
        th.error = true;
        alert('Fichero vacío');
      } else if (data.action === 'limit' || data.action === 'Limit') {
        alert('El excel a generar tiene más de 100 000 filas. Por favor, filtre para reducir el número de filas.');
        th.downloading = false;
        th.error = true;
      }
    };

    this.socket.onopen = function () {
      th.send(th.$route.query);
    };
  },
  methods: {
    send: function (filters) {
      var message = {'type': 'excelcomercial'};
      if (filters['type'] === 'caldera') {
        message['type'] = 'excelcaldera';
      } else if (filters['type'] === 'visitaentidad') {
        message['type'] = 'excelvisitaentidad';
      }
      if (filters) { message['data'] = filters; }
      this.downloading = true;
      this.socket.send(JSON.stringify(message));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Download.vue